import { render, staticRenderFns } from "./PagePart4.vue?vue&type=template&id=038ae15c&scoped=true"
import script from "./PagePart4.vue?vue&type=script&lang=js"
export * from "./PagePart4.vue?vue&type=script&lang=js"
import style0 from "./PagePart4.vue?vue&type=style&index=0&id=038ae15c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ae15c",
  null
  
)

export default component.exports